export const prevNextBtnComponent = {
  key: 'prevNextBtnComponent',
  name: 'Prev Next Btn Dept-Component',
  siteIdentifier: 'global',

  previousAriaLabel: 'Previous',
  nextAriaLabel: 'Next',
};
